'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientsGroupServiceCtrl
 * @description
 * # ClientCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('ClientsGroup', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_CLIENT_URL = domain.name + '/api/v1/client_groups/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_CLIENT_URL,
      baseModelName: 'client_group'
    });

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    return baseService;
  }]);
